import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


class Description extends Component {
  render() {
    return (<Container className='DescriptionBase'>
      <Row className='justify-content-md-center'>
        <Col>
          <ReactMarkdown>
            {this.props.markdown}
          </ReactMarkdown>
        </Col>
      </Row>
    </Container>)
  }
}

export default Description;
